// Copyright (c) 2026 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { FormattedTimeValue } from '@/components/formatted-time-value';
import { Link } from '@/components/link';
import { Contact } from '@/contact/api/types';
import { Chip, Stack, TableCell, TableRow, Typography } from '@mui/material';

interface Props {
  contact: Contact;
  hideCompany?: boolean;
}

export function ContactTableRow(props: Props) {
  const fullName = `${props.contact.firstName} ${props.contact.lastName}`;
  const textColor = props.contact.isArchived ? 'text.disabled' : 'text.primary';

  return (
    <TableRow>
      <TableCell>
        <Stack direction="row" spacing={1} alignItems="center">
          <Link
            to="/contacts/$contactKey"
            params={{ contactKey: props.contact.key }}
            variant="subtitle2"
            color={props.contact.isArchived ? 'text.disabled' : 'primary.main'}
          >
            {fullName}
          </Link>
          {props.contact.isArchived && <Chip size="small" label="Archived" />}
        </Stack>
      </TableCell>
      {!props.hideCompany && (
        <TableCell>
          <Link
            to="/companies/$companyKey"
            params={{ companyKey: props.contact.customer.key }}
            variant="body2"
            color={props.contact.isArchived ? 'text.disabled' : 'text.primary'}
          >
            {props.contact.customer.name}
          </Link>
        </TableCell>
      )}
      <TableCell>
        <Typography variant="body2" color={textColor}>
          {props.contact.title ?? '-'}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2" color={textColor}>
          {props.contact.email ?? '-'}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2" color={textColor}>
          {props.contact.phone ?? '-'}
        </Typography>
      </TableCell>
      <TableCell>
        <FormattedTimeValue timestamp={props.contact.updatedAt} />
      </TableCell>
    </TableRow>
  );
}
